import { Stack, TableCell, TableRow, Typography } from '@mui/material';
import type { Currency } from '@weft/types';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';
import { Price } from 'apps/app/src/components/design/Price';
import { formatPercentage } from 'apps/app/src/utils/number';

type RevenueByCurrencyTableRowProps = {
  total: number;
  percentage: number;
  currency: Currency;
  color: string;
};

export const RevenueByCurrencyTableRow: React.FC<RevenueByCurrencyTableRowProps> = ({ color, total, currency, percentage }) => {
  return (
    <TableRow
      key={crypto.randomUUID()}
      sx={{ '&:last-child td, &:last-child th': { border: 0 }, '& .MuiTableCell-sizeSmall': { paddingY: 2 } }}
    >
      <TableCell
        scope="row"
      >
        <Stack
          direction="row"
          alignItems='center'
          gap={1.5}
        >
          <ColorDot color={color}/>
          <Typography variant='body2'>{currency}</Typography>
        </Stack>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body2'>{formatPercentage(percentage)}</Typography>
      </TableCell>
      <TableCell align="right">
        <Price
          rounded
          className='ml-auto'
          currency={currency}
        >
          {total}
        </Price>
      </TableCell>
    </TableRow>
  );
};